<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOAUTORIZACION.LBL_AUTORIZACIONES' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioControles" name="nomFormularioControles">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOAUTORIZACION.LBL_AUTORIZACION' | translate }}</label>
            <p-dropdown disableTab  id="idAutorizacionv" name="nomAutorizacion" [options]="listaAutorizaciones"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idAutorizacion"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idAutorizacion.invalid">
              {{ 'PRODUCTOAUTORIZACION.LBL_AUTORIZACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' | translate }}</label>
            <textarea type="text" pInputText id="descripcion"
                      name="observacion" maxlength="500"
                      formControlName="descripcion"
                      autocomplete="off"
            ></textarea>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
              {{ 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOAUTORIZACION.LBL_PLANTILLA' | translate }}</label>
            <p-dropdown disableTab  id="idPlantilla" name="nomPlantilla" [options]="listaPlantillas"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idPlantilla"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPlantilla.invalid">
              {{ 'PRODUCTOAUTORIZACION.LBL_PLANTILLA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOAUTORIZACION.LBL_FASE' | translate }}</label>
            <p-dropdown disableTab  id="idFase" name="nomFase" [options]="lisFases" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        formControlName="idFase"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFase.invalid">
              {{ 'PRODUCTOAUTORIZACION.LBL_FASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form flex align-items-center gap-2">
            <p-checkbox formControlName="indicadorAplicaContrato"
                        binary="true"
                        inputId="chkAplicaContrato">
            </p-checkbox>
            <label for="chkAplicaContrato" class="label-form mb-0 cursor-pointer">
              {{ 'PRODUCTOAUTORIZACION.LBL_APLICACONTRATO' | translate }}
            </label>
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
      </div>
    </form>

    <p-accordion [multiple]="true" styleClass="ds-accordion" [(activeIndex)]="acordeonesActivos">
      <p-accordionTab header="{{ 'PRODUCTOAUTORIZACION.LBL_AUTORIZACIONES' | translate }}">
        <ng-container *ngTemplateOutlet="tablaProAutorizaciones; context: { $implicit: listaProAutorizacionesNormales }"></ng-container>
      </p-accordionTab>
      <p-accordionTab header="{{ 'PRODUCTOAUTORIZACION.LBL_CONTRATOS' | translate }}">
        <ng-container *ngTemplateOutlet="tablaProAutorizaciones; context: { $implicit: listaProAutorizacionesContrato }"></ng-container>
      </p-accordionTab>
    </p-accordion>
  </p-panel>
</div>

<ng-template #tablaProAutorizaciones let-lista>
    <div class="grid">
      <div class="hidden md:block md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proControles.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" #proControles
                 [value]="lista" selectionMode="single" dataKey="idProductoAutorizacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreAutorizacion ?? '-'}}</td>
              <td>{{row.descripcion ?? '-'}}</td>
              <td>{{row.nombrePlantilla ?? '-'}}</td>
              <td>{{row.fase ?? '-'}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
</ng-template>


<p-confirmDialog #cd key="controles">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
